import React from 'react';
import { Box, FormLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import FPLstAdvantages from './FP-LstAdvantages';

import logo from '../../images/FamiliplusLongVersion.svg';

import {
  familiplusBox,
  familiplusBoxGrid,
  familiplusBoxInfo,
  familiplusLabel,
  familiplusLogo,
  familiplusTitle,
} from './FP-styles';

import MemberPriceStar from '../../assets/icons/MemberPriceStar.svg';
import BirthdayCake from '../../assets/icons/BirthdayCake.svg';
import PersonalizedOfferTag from '../../assets/icons/PersonalizedOfferTag.svg';
import FamiliplusMobileGift from '../../assets/icons/FamiliplusMobileGift.svg';
import ExclusiveContestPopper from '../../assets/icons/ExclusiveContestPopper.svg';
import HealthyLifeHeart from '../../assets/icons/HealthyLifeHeart.svg';

function FamiliplusAdvantages(): JSX.Element {
  const { t } = useTranslation('component');

  const advantages = [
    {
      icon: MemberPriceStar,
      text: t('FamiliplusAdvantages.MemberPrice'),
    },
    {
      icon: BirthdayCake,
      text: t('FamiliplusAdvantages.BirthdayGift'),
    },
    {
      icon: PersonalizedOfferTag,
      text: t('FamiliplusAdvantages.PersonalizedOffers'),
    },
    {
      icon: FamiliplusMobileGift,
      text: t('FamiliplusAdvantages.FamiliplusMobile'),
    },
    {
      icon: ExclusiveContestPopper,
      text: t('FamiliplusAdvantages.ExclusiveContests'),
    },
    {
      icon: HealthyLifeHeart,
      text: t('FamiliplusAdvantages.HealthyLife'),
    },
  ];

  return (
    <>
      <Box sx={familiplusBox} id="FamiliplusAdvantages">
        <Box sx={familiplusBoxGrid}>
          <Box sx={familiplusBoxInfo}>
            <Box>
              <Box component="img" src={logo} alt="logo" sx={familiplusLogo}></Box>
            </Box>
            <Box>
              <Typography variant="h4" sx={familiplusTitle}>
                {t('FamiliplusAdvantages.Title')}
              </Typography>
            </Box>
            <Box>
              <FormLabel sx={familiplusLabel}>{t('FamiliplusAdvantages.Info')}</FormLabel>
            </Box>
          </Box>
          <FPLstAdvantages advantages={advantages}></FPLstAdvantages>
        </Box>
      </Box>
    </>
  );
}

export default FamiliplusAdvantages;
